import type { ImageAssetType } from '@/components/ui/carousel';

/**
 * DV-3537: the photos the "Missing a Caption" warning counts before a
 * Caption Sort — every photo in the set that is not hidden and has no
 * caption (blank or whitespace-only; JS trim covers NBSP).
 *
 * Deliberately the whole set, NOT the grid's view: the sort re-sequences
 * every photo regardless of the search query or the selection, so a warning
 * narrowed by either would undercount. Hidden photos are left out per the
 * story's AC even though the server sorts them too.
 *
 * Only blank captions count (decided 2026-10-09). Captions that are present
 * but not on the Default Caption Sequence also sink to the end server-side;
 * they are not "missing" and do not trigger the warning.
 */
export const photosMissingCaption = (
  assets: ImageAssetType[]
): ImageAssetType[] =>
  assets.filter((asset) => !asset.hidden && !asset.caption?.trim());
